import { f as e } from "./function-uncurry-this.js";
var t = Map.prototype,
  p = {
    Map: Map,
    set: e(t.set),
    get: e(t.get),
    has: e(t.has),
    remove: e(t.delete),
    proto: t
  };
export { p as m };